export default "__VITE_ASSET__CZXpbMCH__"